import React from 'react'
import { ScrollArea } from '@/components/ui/scroll-area'
import { cn } from '@/lib/utils'

interface PageContainerProps {
  children: React.ReactNode
  scrollable?: boolean
  className?: string
}

const PageContainer: React.FC<PageContainerProps> = ({
  children,
  scrollable = true,
  className
}) => {
  return (
    <>
      {scrollable ? (
        <ScrollArea
          className={cn(
            'mr-2 h-[calc(100dvh-52px)] border-[#E5E5E5] bg-[#F7F7F7]',
            className
          )}
        >
          <div className='text-black-grey h-full p-4'>{children}</div>
        </ScrollArea>
      ) : (
        <div className='text-black-grey h-full border-[#E5E5E5] bg-[#F7F7F7] p-4'>
          {children}
        </div>
      )}
    </>
  )
}

export default PageContainer